import { useState } from "react";
import { useForm } from "react-hook-form";
import { OrderDetailsTable, SuccessModal } from "../../../../components/SharedComponents/sharedComponents.index";
import { useSeetingsViewModel } from "../../../../viewModel/useSettingsViewModel";
import { Card } from "@aidron/aidron-ds";
import { COLUMNS_IDENTIFIERS, USER_ROLES } from "../../../../components/components.constants";
import { CustomHeading } from "../../../../components/StyledComponents/styleComponents.index";
import { i18n } from "../../../../translate/i18n";
import { UpdatingModal } from "../../../../components/SharedComponents/UpdatingModal/UpdatingModal";

import { UserManagementSection } from './components/UserManagementSection'


const ConfirmNewUserModal = ({ actions, ctx }) => {
  
  const { handleCancelRegistration, handleConfirmRegistration } = actions || {};
  const { pendingUserData } = ctx || {};

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "30px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
        }}
      >
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginBottom: "20px",
            color: "#212529"
          }}
        >
          ⚠️ Confirmar Registro de Novo Usuário
        </h2>

        <div
          style={{
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: "8px",
            padding: "15px",
            marginBottom: "20px"
          }}
        >
          <p style={{ fontSize: "14px", color: "#856404", margin: "0 0 10px 0" }}>
            <strong>Atenção:</strong> Você está prestes a registrar um novo usuário no sistema.
          </p>
          <p style={{ fontSize: "14px", color: "#856404", margin: 0 }}>
            <strong>Importante:</strong> Anote as credenciais abaixo antes de prosseguir:
          </p>
        </div>

        {pendingUserData && (
          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "20px",
              border: "1px solid #dee2e6"
            }}
          >
            <div style={{ marginBottom: "10px" }}>
              <strong style={{ fontSize: "14px", color: "#495057" }}>Nome:</strong>
              <p style={{ margin: "4px 0 0 0", fontSize: "14px" }}>
                {pendingUserData.fullName}
              </p>
            </div>
            <div style={{ marginBottom: "10px" }}>
              <strong style={{ fontSize: "14px", color: "#495057" }}>E-mail:</strong>
              <p
                style={{
                  margin: "4px 0 0 0",
                  fontSize: "14px",
                  fontFamily: "monospace",
                  backgroundColor: "#e9ecef",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  display: "inline-block"
                }}
              >
                {pendingUserData.email}
              </p>
            </div>
            <div>
              <strong style={{ fontSize: "14px", color: "#495057" }}>Senha:</strong>
              <p
                style={{
                  margin: "4px 0 0 0",
                  fontSize: "14px",
                  fontFamily: "monospace",
                  backgroundColor: "#e9ecef",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  display: "inline-block"
                }}
              >
                {pendingUserData.password}
              </p>
            </div>
          </div>
        )}

        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button
            onClick={handleCancelRegistration}
            style={{
              padding: "10px 20px",
              border: "1px solid #6c757d",
              borderRadius: "6px",
              backgroundColor: "white",
              color: "#6c757d",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#6c757d";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#6c757d";
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmRegistration}
            style={{
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              backgroundColor: "#28a745",
              color: "white",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#218838";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#28a745";
            }}
          >
            Prosseguir com Registro
          </button>
        </div>
      </div>
    </div>    
  )
};

const ConfirmRemoveUserModal = ({ actions, ctx }) => {
  
  const { handleCancelRemoval, handleConfirmRemoval } = actions || {};
  const { pendingRemovalUser } = ctx || {};

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "30px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
        }}
      >
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginBottom: "20px",
            color: "#212529"
          }}
        >
          ⚠️ Confirmar Remoção de Usuário
        </h2>

        <div
          style={{
            backgroundColor: "#f8d7da",
            border: "1px solid #dc3545",
            borderRadius: "8px",
            padding: "15px",
            marginBottom: "20px"
          }}
        >
          <p style={{ fontSize: "14px", color: "#721c24", margin: "0 0 10px 0" }}>
            <strong>Atenção:</strong> Você está prestes a remover um usuário do sistema.
          </p>
          <p style={{ fontSize: "14px", color: "#721c24", margin: 0 }}>
            <strong>Esta ação não pode ser desfeita!</strong> O usuário perderá acesso à plataforma.
          </p>
        </div>

        {pendingRemovalUser && (
          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "20px",
              border: "1px solid #dee2e6"
            }}
          >
            <div style={{ marginBottom: "10px" }}>
              <strong style={{ fontSize: "14px", color: "#495057" }}>Usuário:</strong>
              <p style={{ margin: "4px 0 0 0", fontSize: "14px" }}>
                {pendingRemovalUser.username}
              </p>
            </div>

            <div>
              <strong style={{ fontSize: "14px", color: "#495057" }}>Hierarquia:</strong>
              <p
                style={{
                  margin: "4px 0 0 0",
                  fontSize: "14px",
                  fontFamily: "monospace",
                  backgroundColor: "#e9ecef",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  display: "inline-block"
                }}
              >
                {pendingRemovalUser.role}
              </p>
            </div>

            <div>
              <strong style={{ fontSize: "14px", color: "#495057" }}>Loja:</strong>
              <p
                style={{
                  margin: "4px 0 0 0",
                  fontSize: "14px",
                  fontFamily: "monospace",
                  backgroundColor: "#e9ecef",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  display: "inline-block"
                }}
              >
                {pendingRemovalUser.stores}
              </p>
            </div>            

          </div>
        )}

        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button
            onClick={handleCancelRemoval}
            style={{
              padding: "10px 20px",
              border: "1px solid #6c757d",
              borderRadius: "6px",
              backgroundColor: "white",
              color: "#6c757d",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#6c757d";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#6c757d";
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmRemoval}
            style={{
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              backgroundColor: "#dc3545",
              color: "white",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#c82333";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#dc3545";
            }}
          >
            Confirmar Remoção
          </button>
        </div>
      </div>
    </div>    
  )
};

export function UsersManagement() {
  const [selectedUser, setSelectedUser] = useState("");
  
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [pendingUserData, setPendingUserData] = useState(null);
  const [pendingRemovalUser, setPendingRemovalUser] = useState(null);

  const [dataToDisplayToTenantAdmin, setDataToDisplayToTenantAdmin] = useState({});

  const [onSuccessRegister, setOnSuccessRegister] = useState(false);
  
  const { t } = i18n;
  const vm = useSeetingsViewModel({ shouldFetchUsersInformation: true });
  
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      fullName: "",
      email: "",
      role: "",
      password: "",
      stores: []
    }
  });

  const onSubmitForm = async (data) => {
    setPendingUserData(data);
    setShowConfirmModal(true);
  };

  const handleConfirmRegistration = async () => {
    if (!pendingUserData) return;

    const data = { ...pendingUserData, tenant: vm.ctx.usersTenant };

    try {
      const dataToDisplayToTenantAdmin = await vm.actions.registerUser(data);
      setShowConfirmModal(false);
      setPendingUserData(null);
      reset();
      setDataToDisplayToTenantAdmin(dataToDisplayToTenantAdmin)
      setOnSuccessRegister(true)
      await vm.actions.refetchUserCtx();
      return dataToDisplayToTenantAdmin;
    } catch (err) {
      setShowConfirmModal(false);
      throw err;
    }
  };

  const handleCancelRegistration = () => {
    setShowConfirmModal(false);
    setPendingUserData(null);
  };

  const handleRequestUserRemoval = () => {
    if (!selectedUser) return;
    setPendingRemovalUser(selectedUser);
    setShowCancelModal(true);
  };

  const handleRemoveUser = async () => {
    if (!selectedUser) return;

    try {
      await vm.actions.deactivateUserInTenantApp(selectedUser?.userId);
      setSelectedUser("");
      setShowCancelModal(false);
      setPendingRemovalUser(null);
      
    } catch (err) {
      throw err;
    }
  };

  const selectedRole = watch("role");

  return (
    <>
      {/* Modal de Confirmação */}
      {showConfirmModal && (
        <ConfirmNewUserModal 
          actions={{ 
            handleConfirmRegistration: handleConfirmRegistration, 
            handleCancelRegistration: handleCancelRegistration 
          }}
          ctx={{ pendingUserData: pendingUserData }}
        />
      )}

      {vm.uiState.isRegisteringUser && (
        <UpdatingModal 
          ctx={{
            label: {
              primaryMessage: "Registrando usuário. Aguarde..."
            }
          }}
          uiState={{ 
            loadingAction: vm.uiState.isRegisteringUser,
            isSettingsPage: true
          }}
        />
      )}

      {onSuccessRegister && (
        <SuccessModal 
          actions={{ setShowSuccessModal: setOnSuccessRegister }}
          ctx={{
            dataToDisplayToTenantAdmin: dataToDisplayToTenantAdmin?.data || {},
            t: t
          }}
          uiState={{
            isSettingsPage: true
          }}
        />
      )}

      {/* Remoção */}
      {showCancelModal && (
        <ConfirmRemoveUserModal 
          actions={{
            handleConfirmRemoval: handleRemoveUser,
            handleCancelRemoval: () => setShowCancelModal(false)
          }}
          ctx={{ pendingRemovalUser: pendingRemovalUser }}
        />        
      )}

      {vm.uiState.isDeactivatingUser && (
        <UpdatingModal 
          ctx={{
            label: {
              primaryMessage: "Removendo usuário. Aguarde..."
            }
          }}
          uiState={{ 
            loadingAction: vm.uiState.isDeactivatingUser,
            isSettingsPage: true
          }}
        />
      )}      

      <UserManagementSection 
        actions={{
          setSelectedUser: setSelectedUser, 
          handleRequestUserRemoval: handleRequestUserRemoval,
          onSubmitForm: onSubmitForm, 
          handleSubmit: handleSubmit
        }}
        ctx={{
          selectOptions: vm.ctx.selectOptions,
          selectedUser: selectedUser,
          selectedRole: selectedRole, 
          storesByRegion: vm.ctx.storesByRegion || []  
        }}
        uiState={{
          register: register,
          errors: errors,
          activeSection: 'both'
        }}
      />


      {/* Card separado para a Tabela de Usuários Ativos */}
      <Card
        style={{
          margin: "20px 0",
          padding: "20px 30px"
        }}
      >
        <div style={{ marginBottom: "15px" }}>
          <CustomHeading
            fontSize={["0.3rem", "0.9rem", "1.3rem"]}
            inlineSize={"fit-content"}
          >
            👥 Usuários Ativos
          </CustomHeading>
          <p style={{ fontSize: "14px", color: "#6c757d", marginTop: "5px" }}>
            Lista de todos os usuários cadastrados no sistema
          </p>
        </div>

        <OrderDetailsTable
          ctx={{
            columns: vm.ctx.columns[1],
            tableSourceData:
              vm.ctx.usersInformation?.users.filter(
                (u) => u.role !== USER_ROLES.ADMIN
              ) || [],
            tableSourceMetaData: {
              enableSorting: true,
              sortingMode: {
                id: COLUMNS_IDENTIFIERS.DEPARTMENT,
                desc: false
              }
            }
          }}
        />
      </Card>
    </>
  );
}